import React from 'react'
import { Dialog, Button, DialogContent, Text } from '@resiliatech/birdsong'
import {
  HeaderContainer,
  TitleSection,
  ButtonContainer,
} from '../ProgressUpdateDialog/ProgressUpdateDialog.styled'
import {
  CloseButton,
  AlertBox,
  TextBox,
} from './ProgressUpdateIntroModal.styled'

type ProgressUpdateIntroProps = {
  open: boolean
  onClose: () => void
  onGetStarted: () => void
}

export const ProgressUpdateIntroModal = ({
  open,
  onClose,
  onGetStarted,
}: ProgressUpdateIntroProps) => (
  <Dialog open={open} onClose={onClose} maxWidth='sm'>
    <HeaderContainer>
      <TitleSection>Let’s track your progress using updates!</TitleSection>
      <CloseButton onClick={onClose} size='small' />
    </HeaderContainer>
    <DialogContent>
      <AlertBox>
        <img
          src='https://res.cloudinary.com/resilia/image/upload/assets/impact_outcomes.png'
          alt='Impact Outcomes'
          style={{ maxWidth: '100%', height: 'auto' }}
        />
      </AlertBox>
      <TextBox>
        <Text variant='body1'>
          We are here to support you every step of the way! As you work within
          the platform, you will answer questions to help track your progress
          toward impact.
        </Text>
      </TextBox>
      <TextBox>
        <Text variant='body1'>
          You can assign tasks and receive progress updates by aligning your
          team’s activities to specific goals. These updates will help you tell
          more impactful stories about your achievements.
        </Text>
      </TextBox>
      <ButtonContainer>
        <Button variant='primary' onClick={onGetStarted} label='Get Started' />
      </ButtonContainer>
    </DialogContent>
  </Dialog>
)
